export const getDisOrderMembers = (members)=>{
  return members.sort(() => Math.random() > 0.5 ? -1 : 1);
};

export const getGroupNum = (total, memberNum, groupNum) =>{
  const res = new Array(groupNum).fill(memberNum);
  const leaseGroup = memberNum * groupNum - total;
  for (let i = 1; i <= leaseGroup; i++) {
    res[groupNum - i] = res[groupNum - i] - 1;
  }
  return res;
};

export const getSplitMembers = (members)=>{
  const res = [];
  const depts = {};
  const deptLens = {};
  let maxLen = 0;
  let deptIds = [];
  members.forEach(item => {
    if (!depts[item.deptId]) {
      depts[item.deptId] = [];
      deptLens[item.deptId] = 0;
      deptIds.push(item.deptId);
    }
    depts[item.deptId].push(item);
    deptLens[item.deptId]++;
    if (deptLens[item.deptId] > maxLen) {
      maxLen = deptLens[item.deptId];
    }
  });
  for (let x = 0; x < maxLen;x++) {
    for (let y = 0;y < deptIds.length ;y++) {
      if (depts[deptIds[y]][x]) {
        console.log(depts[deptIds[y]][x].deptId);
        res.push(depts[deptIds[y]][x]);
      }
    }
  }
  return res;
};

// 分组求和，这个网上一堆实现
function combinationSum(candidates, target) {
  let arr = candidates.sort((m, n) => m - n);
  let res = [];

  function def(nums, path, target) {
    for (let i = 0; i < nums.length; i++) {
      let curPath = [...path, nums[i]];
      let curTarget = target - nums[i];

      // why? 只是为了算法优化 处理第一次计算小于0得情况  避免重复计算
      // 当 target - nums[0] < 0 后  避免连续重复数字得计算
      if (i > 0 && nums[i - 1] === nums[i]) {
        continue;
      }
      if (curTarget === 0) {
        res.push(curPath);
      }
      if (curTarget >= nums[i]) {
        def(nums.slice(i + 1), curPath, curTarget);
      }
    }
  }

  def(arr, [], target);
  return res;
}

// 去除子数组
function removeSubArray(arrA, arrB) {
  const result = arrA.slice();
  arrB.forEach(item => {
    const index = result.indexOf(item);
    if (index > -1) {
      result.splice(index, 1);
    }
  });
  return result;
}

// 求和
function sum(arr) {
  return arr.reduce((a, b) => a + b, 0);
}

// 取符合N:1组合且人数最多的子数组
function getMaxSubsets(departmentList, groupList) {
  let count = 0;
  let subDepartmentList = [];
  let subGroupList = [];
  if (!groupList.length) {
    return [count, subDepartmentList, subGroupList];
  }

  departmentList = departmentList.slice();
  groupList = groupList.slice();
  while (true) {
    if (!groupList.length) {
      break;
    }
    const group = groupList[0];
    // 获取数组中值等于目标值得所有可能性 8 [1,7] [2,6]
    const subsets = combinationSum(departmentList, group);
    groupList.splice(0, 1);
    if (subsets.length) {
      let maxCount = 0;
      let maxSubset = null;
      let maxResult = null;
      // 遍历剩余数据
      for (let subset of subsets) {
        const result = getMaxSubsets(
          removeSubArray(departmentList, subset),
          groupList
        );
        const max = sum(subset) + sum(result[1]);
        if (max > maxCount) {
          maxCount = max;
          maxSubset = subset;
          maxResult = result;
        }
      }

      count = maxCount;
      subDepartmentList = subDepartmentList
        .concat(maxSubset)
        .concat(maxResult[1]);
      subGroupList = subGroupList.concat([group]).concat(maxResult[2]);
      break;
    }
  }
  return [count, subDepartmentList, subGroupList];
}

/*
* 实际业务场景，人更在乎自己部门拆分的情况，所以重点考虑部门合、拆的情况，局部最优即可。多个部门、多个组之间的最优解，不是很重要。
* 1. 先正向匹配，取部门:组=N:1组合，满足匹配的最大人数
* 2. 再反向匹配，取部门:组=1:N组合，满足匹配的最大人数
* 3. 把部门往组里顺序填充
*/
function bestDivide(departmentList, groupList) {
  // 初始化返回数组
  const outputList = new Array(departmentList.length)
    .fill(0)
    .map(x => new Array(groupList.length).fill(0));

  let splitIndex = 0;
  // 拷贝
  let copyDepartmentList = departmentList.slice();
  let copyGroupList = groupList.slice();

  // 正向匹配，不增加splitIndex
  const [maxComCount, subComDepartmentList, subComGroupList] = getMaxSubsets(
    departmentList,
    groupList
  );
  if (maxComCount > 0) {
    let partial = 0;
    const copySubComGroupList = subComGroupList.slice();
    for (let department of subComDepartmentList) {
      const departmentIndex = copyDepartmentList.indexOf(department);
      const group = copySubComGroupList[0];
      const groupIndex = copyGroupList.indexOf(group);
      outputList[departmentIndex][groupIndex] = department;
      copyDepartmentList[departmentIndex] = 0;
      if (group === department + partial) {
        partial = 0;
        copySubComGroupList.splice(0, 1);
        copyGroupList[groupIndex] = 0;
      } else {
        partial += department;
      }
    }
  }

  // 反向匹配，增加splitIndex
  const [
    minSplitCount,
    subSplitGroupList,
    subSplitDepartmentList
  ] = getMaxSubsets(
    removeSubArray(groupList, subComGroupList),
    removeSubArray(departmentList, subComDepartmentList)
  );
  if (minSplitCount > 0) {
    let partial = 0;
    const copySubSplitDepartmentList = subSplitDepartmentList.slice();
    for (let group of subSplitGroupList) {
      const groupIndex = copyGroupList.indexOf(group);
      const department = copySubSplitDepartmentList[0];
      const departmentIndex = copyDepartmentList.indexOf(department);
      outputList[departmentIndex][groupIndex] = group;
      copyGroupList[groupIndex] = 0;
      if (group === department - partial) {
        partial = 0;
        copySubSplitDepartmentList.splice(0, 1);
        copyDepartmentList[departmentIndex] = 0;
      } else {
        partial += group;
      }
    }
    splitIndex = subSplitGroupList.length - subSplitDepartmentList.length;
  }

  // 顺序填充，部门超出组人数增加splitIndex
  const subLeftDepartmentList = removeSubArray(
    removeSubArray(departmentList, subComDepartmentList),
    subSplitDepartmentList
  );
  const subLeftGroupList = removeSubArray(
    removeSubArray(groupList, subComGroupList),
    subSplitGroupList
  );
  const fillR = function(subLeftDepartmentList, subLeftGroupList) {
    subLeftDepartmentList = subLeftDepartmentList.slice();
    subLeftGroupList = subLeftGroupList.slice();

    if (subLeftDepartmentList.length) {
      const department = subLeftDepartmentList[0];
      const group = subLeftGroupList[0];
      const departmentIndex = copyDepartmentList.indexOf(department);
      const groupIndex = copyGroupList.indexOf(group);
      const diff = department - group;
      if (diff > 0) {
        outputList[departmentIndex][groupIndex] = group;
        copyDepartmentList[departmentIndex] = diff;
        copyGroupList[groupIndex] = 0;
        subLeftDepartmentList[0] = diff;
        subLeftGroupList.splice(0, 1);
        splitIndex++;
      } else if (diff === 0) {
        outputList[departmentIndex][groupIndex] = group;
        copyDepartmentList[departmentIndex] = 0;
        copyGroupList[groupIndex] = 0;
        subLeftDepartmentList.splice(0, 1);
        subLeftGroupList.splice(0, 1);
      } else {
        outputList[departmentIndex][groupIndex] = department;
        copyDepartmentList[departmentIndex] = 0;
        copyGroupList[groupIndex] = -diff;
        subLeftDepartmentList.splice(0, 1);
        subLeftGroupList[0] = -diff;
      }

      fillR(subLeftDepartmentList, subLeftGroupList);
    }
  };
  fillR(subLeftDepartmentList, subLeftGroupList);
  console.log(splitIndex);
  return outputList;
}
export const getSameMembers = (members, groupsNum) =>{
  let res = [];
  const deptLens = {};
  const depts = {};
  const deptIds = [];

  members.forEach(item => {
    if (!deptLens[item.deptId]) {
      depts[item.deptId] = [];
      deptLens[item.deptId] = 0;
      deptIds.push(item.deptId);
    }
    deptLens[item.deptId]++;
    depts[item.deptId].push(item);
  });
  const deptsNum = Object.values(deptLens);
  const resInfo = bestDivide(deptsNum, groupsNum);

  for (let x = 0; x < resInfo[0].length;x++) {
    for (let y = 0;y < resInfo.length ;y++) {
      if (resInfo[y][x] && depts[deptIds[y]]) {
        const current = depts[deptIds[y]].splice(0, resInfo[y][x]);
        res = res.concat(current);
      }
    }
  }
  return res;
};
